export const PAGE_CONSTANT = {
  MAIN: {
    SUB_TYPE: {
      BN001: 'BN001',
      BN002: 'BN002',
      BN003: 'BN003',
      BN004: 'BN004',
      BN005: 'BN005',
      BN013: 'BN013',
      TP001: 'TP001',
      TP002: 'TP002',
      TP003: 'TP003',
      BP001: 'BP001',
      BP002: 'BP002',
      BP005: 'BP005',
      PD001: 'PD001',
      PD002: 'PD002',
      PD003: 'PD003',
      PD004: 'PD004',
      PD010: 'PD010',
      CT001: 'CT001',
      CT002: 'CT002',
      TGP001: 'TGP001',
      TGP007: 'TGP007',
    },
    MARKETING_TYPE: {
      MAIN_BOTTOM: 'MAIN_BOTTOM',
      MAIN_SLIDING: 'MAIN_SLIDING',
    },
  },
  BEST: {
    ERROR_MSG: {
      TYPE: 'api',
      DETAIL:
        '베스트 상품이 없습니다.​<br />카테고리 또는 성별을​<br />변경해 보세요.​',
    },
  },
  SEARCH: {
    FILTER_LIST: [
      {
        text: '카테고리',
        activeText: '',
        value: 'filterCategoryTab',
        type: 'category',
      },
      { text: '컬러', activeText: '', value: 'filterColorTab', type: 'color' },
      { text: '가격', activeText: '', value: 'filterPriceTab', type: 'price' },
      {
        text: '할인/혜택',
        activeText: '',
        value: 'filterBenefitTab',
        type: 'benefit',
      },
      {
        text: '브랜드',
        activeText: '',
        value: 'filterBrandTab',
        type: 'brand',
      },
    ],
    COLOR_LIST: [
      { name: '화이트', code: 'white', key: 0 },
      { name: '그레이', code: 'grey', key: 1 },
      { name: '블랙', code: 'black', key: 2 },
      { name: '레드', code: 'red', key: 3 },
      { name: '카멜', code: 'camel', key: 4 },
      { name: '옐로우', code: 'yellow', key: 5 },
      { name: '그린', code: 'green', key: 6 },
      { name: '블루', code: 'blue', key: 7 },
      { name: '네이비', code: 'navy', key: 8 },
      { name: '퍼플', code: 'purple', key: 9 },
      { name: '핑크', code: 'pink', key: 10 },
      { name: '브라운', code: 'brown', key: 11 },
      { name: '파스텔', code: 'pastel', key: 12 },
      { name: '패턴', code: 'pattern', key: 13 },
      { name: '메탈릭', code: 'metallic', key: 14 },
    ],
    BENEFIT_LIST: [
      { name: '세일중', code: 'sale', type: 'discount', key: 1 },
      { name: '상품쿠폰', code: 'coupon', type: 'discount', key: 3 },
      { name: '무료배송', code: 'freeDelivery', type: 'benefit', key: 0 },
      { name: '단독', code: 'exclusive', type: 'benefit', key: 6 },
      {
        name: '예약/주문 제외',
        code: 'excludePreOrder',
        type: 'benefit',
        key: 5,
      },
      { name: '증정품', code: 'gift', type: 'benefit', key: 2 },
    ],
    SORT_LIST: [
      { name: '신상품순', code: 'NEW', key: 0 },
      { name: '판매순', code: 'SALE', key: 1 },
      { name: '할인율순', code: 'DISCOUNT', key: 2 },
      { name: '낮은가격순', code: 'LOWPRICE', key: 3 },
      { name: '높은가격순', code: 'HIGHPRICE', key: 4 },
      { name: '리뷰순', code: 'REVIEW', key: 5 },
      { name: '추천순', code: 'WCK', key: 8 },
    ],
  },
  COUPON: {
    FILTER_LIST: [
      {
        text: '카테고리',
        activeText: '',
        value: 'category',
        type: 'category',
      },
      { text: '컬러', activeText: '', value: 'color', type: 'color' },
      { text: '가격', activeText: '', value: 'priceRange', type: 'priceRange' },
      {
        text: '상품정보',
        activeText: '',
        value: 'benefit',
        type: 'benefit',
      },
      {
        text: '브랜드',
        activeText: '',
        value: 'topBrand',
        type: 'brand',
        subType: ['brand', 'topBrand', 'newBrand'],
      },
    ],
    COLOR_LIST: [
      { name: '화이트', code: 'white', key: 0 },
      { name: '그레이', code: 'grey', key: 1 },
      { name: '블랙', code: 'black', key: 2 },
      { name: '레드', code: 'red', key: 3 },
      { name: '카멜', code: 'camel', key: 4 },
      { name: '옐로우', code: 'yellow', key: 5 },
      { name: '그린', code: 'green', key: 6 },
      { name: '블루', code: 'blue', key: 7 },
      { name: '네이비', code: 'navy', key: 8 },
      { name: '퍼플', code: 'purple', key: 9 },
      { name: '핑크', code: 'pink', key: 10 },
      { name: '브라운', code: 'brown', key: 11 },
      { name: '파스텔', code: 'pastel', key: 12 },
      { name: '패턴', code: 'pattern', key: 13 },
      { name: '메탈릭', code: 'metallic', key: 14 },
    ],
    BENEFIT_LIST: [
      { name: '세일중', code: 'sale', type: 'discount', key: 1 },
      { name: '상품쿠폰', code: 'coupon', type: 'discount', key: 3 },
      { name: '무료배송', code: 'freeDelivery', type: 'benefit', key: 0 },
      { name: '단독', code: 'exclusive', type: 'benefit', key: 6 },
      {
        name: '예약/주문 제외',
        code: 'excludePreOrder',
        type: 'benefit',
        key: 5,
      },
      { name: '증정품', code: 'gift', type: 'benefit', key: 2 },
    ],
    SORT_LIST: [
      { name: '신상품순', code: 'NEW', key: 0 },
      { name: '판매순', code: 'SALE', key: 1 },
      { name: '할인율순', code: 'DISCOUNT', key: 2 },
      { name: '낮은가격순', code: 'LOWPRICE', key: 3 },
      { name: '높은가격순', code: 'HIGHPRICE', key: 4 },
      { name: '리뷰순', code: 'REVIEW', key: 5 },
    ],
  },
  BRAND: {
    SUB_TYPE: {
      BN007: 'BN007',
      CT001: 'CT001',
      CT003: 'CT003',
      PD006: 'PD006',
      CT004: 'CT004',
      CT005: 'CT005',
    },
    FILTER_LIST: [
      { text: '컬러', activeText: '', value: 'color', type: 'color' },
      {
        text: '스타일',
        activeText: '',
        type: 'style',
        value: 'style',
      },
      {
        text: 'TPO',
        activeText: '',
        type: 'tpo',
        value: 'tpo',
      },
      { text: '가격', activeText: '', value: 'priceRange', type: 'priceRange' },
      {
        text: '상품정보',
        activeText: '',
        value: 'benefit',
        type: 'benefit',
      },
    ],
    COLOR_LIST: [
      { name: '화이트', code: 'white', key: 0 },
      { name: '그레이', code: 'grey', key: 1 },
      { name: '블랙', code: 'black', key: 2 },
      { name: '레드', code: 'red', key: 3 },
      { name: '카멜', code: 'camel', key: 4 },
      { name: '옐로우', code: 'yellow', key: 5 },
      { name: '그린', code: 'green', key: 6 },
      { name: '블루', code: 'blue', key: 7 },
      { name: '네이비', code: 'navy', key: 8 },
      { name: '퍼플', code: 'purple', key: 9 },
      { name: '핑크', code: 'pink', key: 10 },
      { name: '브라운', code: 'brown', key: 11 },
      { name: '파스텔', code: 'pastel', key: 12 },
      { name: '패턴', code: 'pattern', key: 13 },
      { name: '메탈릭', code: 'metallic', key: 14 },
    ],
    BENEFIT_LIST: [
      { name: '세일중', code: 'sale', type: 'discount', key: 1 },
      { name: '상품쿠폰', code: 'coupon', type: 'discount', key: 3 },
      { name: '무료배송', code: 'freeDelivery', type: 'benefit', key: 0 },
      { name: '단독', code: 'exclusive', type: 'benefit', key: 6 },
      {
        name: '예약/주문 제외',
        code: 'excludePreOrder',
        type: 'benefit',
        key: 5,
      },
      { name: '증정품', code: 'gift', type: 'benefit', key: 2 },
    ],
    SORT_LIST: [
      { name: '신상품순', code: 'NEW', key: 0 },
      { name: '판매순', code: 'SALE', key: 1 },
      { name: '할인율순', code: 'DISCOUNT', key: 2 },
      { name: '낮은가격순', code: 'LOWPRICE', key: 3 },
      { name: '높은가격순', code: 'HIGHPRICE', key: 4 },
      { name: '리뷰순', code: 'REVIEW', key: 5 },
    ],
  },
  CATEGORY: {
    BN003: 'BN003',
    BN005: 'BN005',
    BN006: 'BN006',
    PD004: 'PD004',
    PD005: 'PD005',
    BP001: 'BP001',
    BP002: 'BP002',
    TP001: 'TP001',
    TTP001: 'TTP001',
    TP003: 'TP003',
    // LP V2 필터바 — SALE 과 같은 순서(스타일/TPO 는 데이터 없으면 미노출)
    FILTER_LIST: [
      {
        text: '카테고리',
        activeText: '',
        value: 'category',
        type: 'category',
      },
      { text: '컬러', activeText: '', value: 'color', type: 'color' },
      { text: '스타일', activeText: '', type: 'style', value: 'style' },
      { text: 'TPO', activeText: '', type: 'tpo', value: 'tpo' },
      { text: '가격', activeText: '', value: 'priceRange', type: 'priceRange' },
      {
        text: '브랜드',
        activeText: '',
        value: 'topBrand',
        type: 'brand',
        subType: ['brand', 'topBrand', 'newBrand'],
      },
      { text: '상품정보', activeText: '', value: 'benefit', type: 'benefit' },
    ],
    COLOR_LIST: [
      { name: '화이트', code: 'white', key: 0 },
      { name: '그레이', code: 'grey', key: 1 },
      { name: '블랙', code: 'black', key: 2 },
      { name: '레드', code: 'red', key: 3 },
      { name: '카멜', code: 'camel', key: 4 },
      { name: '옐로우', code: 'yellow', key: 5 },
      { name: '그린', code: 'green', key: 6 },
      { name: '블루', code: 'blue', key: 7 },
      { name: '네이비', code: 'navy', key: 8 },
      { name: '퍼플', code: 'purple', key: 9 },
      { name: '핑크', code: 'pink', key: 10 },
      { name: '브라운', code: 'brown', key: 11 },
      { name: '파스텔', code: 'pastel', key: 12 },
      { name: '패턴', code: 'pattern', key: 13 },
      { name: '메탈릭', code: 'metallic', key: 14 },
    ],
    BENEFIT_LIST: [
      { name: '세일중', code: 'sale', type: 'discount', key: 1 },
      { name: '상품쿠폰', code: 'coupon', type: 'discount', key: 3 },
      { name: '무료배송', code: 'freeDelivery', type: 'benefit', key: 0 },
      { name: '단독', code: 'exclusive', type: 'benefit', key: 6 },
      {
        name: '예약/주문 제외',
        code: 'excludePreOrder',
        type: 'benefit',
        key: 5,
      },
      { name: '증정품', code: 'gift', type: 'benefit', key: 2 },
    ],
    SORT_LIST: [
      { name: '신상품순', code: 'NEW', key: 0 },
      { name: '판매순', code: 'SALE', key: 1 },
      { name: '할인율순', code: 'DISCOUNT', key: 2 },
      { name: '낮은가격순', code: 'LOWPRICE', key: 3 },
      { name: '높은가격순', code: 'HIGHPRICE', key: 4 },
      { name: '리뷰순', code: 'REVIEW', key: 5 },
    ],
  },
  PB_BRAND: {
    SUB_TYPE: {
      BN008: 'BN008',
      BN009: 'BN009',
      BP002: 'BP002',
      TGP002: 'TGP002',
      TP002: 'TP002',
      CT005: 'CT005',
      PP001: 'PP001',
      TP003: 'TP003',
      CT006: 'CT006',
    },
  },
  PROMOTION: {
    PROMOTION_FILTER_LIST: [
      {
        text: '카테고리',
        activeText: '',
        value: 'category',
        type: 'category',
      },
    ],
  },
  NEW: {
    SUB_TYPE: {
      PD003: 'PD003',
      BP001: 'BP001',
      TTP001: 'TTP001',
      TP003: 'TP003',
      PD007: 'PD007',
    },

    NEW_FILTER_LIST: [
      {
        text: '카테고리',
        activeText: '',
        value: 'category',
        type: 'category',
      },
      { text: '컬러', activeText: '', value: 'color', type: 'color' },
      {
        text: '스타일',
        activeText: '',
        type: 'style',
        value: 'style',
      },
      {
        text: 'TPO',
        activeText: '',
        type: 'tpo',
        value: 'tpo',
      },
      { text: '가격', activeText: '', value: 'priceRange', type: 'priceRange' },
      {
        text: '브랜드',
        activeText: '',
        value: 'topBrand',
        type: 'brand',
        subType: ['brand', 'topBrand', 'newBrand'],
      },
      {
        text: '상품정보',
        activeText: '',
        value: 'benefit',
        type: 'benefit',
      },
    ],
    FILTER_LIST: [
      {
        text: '카테고리',
        activeText: '',
        value: 'filterCategoryTab',
        type: 'category',
      },
      { text: '컬러', activeText: '', value: 'filterColorTab', type: 'color' },
      { text: '가격', activeText: '', value: 'filterPriceTab', type: 'price' },
      {
        text: '할인/혜택',
        activeText: '',
        value: 'filterBenefitTab',
        type: 'benefit',
      },
      {
        text: '브랜드',
        activeText: '',
        value: 'filterBrandTab',
        type: 'brand',
      },
    ],
    COLOR_LIST: [
      { name: '화이트', code: 'white', key: 0 },
      { name: '그레이', code: 'grey', key: 1 },
      { name: '블랙', code: 'black', key: 2 },
      { name: '레드', code: 'red', key: 3 },
      { name: '카멜', code: 'camel', key: 4 },
      { name: '옐로우', code: 'yellow', key: 5 },
      { name: '그린', code: 'green', key: 6 },
      { name: '블루', code: 'blue', key: 7 },
      { name: '네이비', code: 'navy', key: 8 },
      { name: '퍼플', code: 'purple', key: 9 },
      { name: '핑크', code: 'pink', key: 10 },
      { name: '브라운', code: 'brown', key: 11 },
      { name: '파스텔', code: 'pastel', key: 12 },
      { name: '패턴', code: 'pattern', key: 13 },
      { name: '메탈릭', code: 'metallic', key: 14 },
    ],
    BENEFIT_LIST: [
      { name: '세일중', code: 'sale', type: 'discount', key: 1 },
      { name: '상품쿠폰', code: 'coupon', type: 'discount', key: 3 },
      { name: '무료배송', code: 'freeDelivery', type: 'benefit', key: 0 },
      { name: '단독', code: 'exclusive', type: 'benefit', key: 6 },
      {
        name: '예약/주문 제외',
        code: 'excludePreOrder',
        type: 'benefit',
        key: 5,
      },
      { name: '증정품', code: 'gift', type: 'benefit', key: 2 },
    ],
    SORT_LIST: [
      { name: '신상품순', code: 'NEW', key: 0 },
      { name: '판매순', code: 'SALE', key: 1 },
      { name: '할인율순', code: 'DISCOUNT', key: 2 },
      { name: '낮은가격순', code: 'LOWPRICE', key: 3 },
      { name: '높은가격순', code: 'HIGHPRICE', key: 4 },
      { name: '리뷰순', code: 'REVIEW', key: 5 },
    ],
  },
  SPECIALTY: {
    SUB_TYPE: {
      BN006: 'BN006',
      BN002: 'BN002',
      BN010: 'BN010',
      BN003: 'BN003',
      TP001: 'TP001',
      CT007: 'CT007',
      CT008: 'CT008',
      TP003: 'TP003',
      BP002: 'BP002',
      BP003: 'BP003',
      CT009: 'CT009',
    },
    SORT_LIST: [
      { name: '신상품순', code: 'NEW', key: 0 },
      { name: '판매순', code: 'SALE', key: 1 },
      { name: '할인율순', code: 'DISCOUNT', key: 2 },
      { name: '낮은가격순', code: 'LOWPRICE', key: 3 },
      { name: '높은가격순', code: 'HIGHPRICE', key: 4 },
      { name: '리뷰순', code: 'REVIEW', key: 5 },
    ],
  },
  SPC: {
    NAVIGATION_SPC_TYPES: ['SPC001', 'SPC002'],
    GA4_PAGE_NAME: {
      SPC001: 'W NEXT',
      SPC002: 'W ICON',
      SPC003: 'HYPERGROUND',
      SPC004: '아울렛',
      SPC005: '럭셔리',
      SPC006: '캐주얼',
    },
    SUB_TYPE: {
      BN006: 'BN006',
      BN002: 'BN002',
      BN010: 'BN010',
      BN003: 'BN003',
      TP001: 'TP001',
      CT007: 'CT007',
      CT008: 'CT008',
      TP003: 'TP003',
      BP002: 'BP002',
      BP003: 'BP003',
      CT009: 'CT009',
    },
    SORT_LIST: [
      { name: '신상품순', code: 'NEW', key: 0 },
      { name: '판매순', code: 'SALE', key: 1 },
      { name: '할인율순', code: 'DISCOUNT', key: 2 },
      { name: '낮은가격순', code: 'LOWPRICE', key: 3 },
      { name: '높은가격순', code: 'HIGHPRICE', key: 4 },
      { name: '리뷰순', code: 'REVIEW', key: 5 },
    ],
    FILTER_LIST: [
      {
        text: '카테고리',
        activeText: '',
        value: 'category',
        type: 'category',
      },
      { text: '컬러', activeText: '', value: 'color', type: 'color' },
      { text: '가격', activeText: '', value: 'priceRange', type: 'priceRange' },
      {
        text: '브랜드',
        activeText: '',
        value: 'topBrand',
        type: 'brand',
        subType: ['brand', 'topBrand', 'newBrand'],
      },
      {
        text: '상품정보',
        activeText: '',
        value: 'benefit',
        type: 'benefit',
      },
    ],
  },
  ALLY: {
    SUB_TYPE: {
      BN001: 'BN001',
      BN002: 'BN002',
      BN004: 'BN004',
      PD006: 'PD006',
      PD005: 'PD005',
      BP001: 'BP001',
      TP003: 'TP003',
      BP004: 'BP004',
      BN012: 'BN012',
    },
  },
  SALE: {
    SUB_TYPE: {
      PD008: 'PD008',
      BN011: 'BN011',
      TGP003: 'TGP003',
      TGP004: 'TGP004',
      PD009: 'PD009',
      BN012: 'BN012',
    },
    FILTER_LIST: [
      {
        text: '카테고리',
        activeText: '',
        value: 'category',
        type: 'category',
      },
      { text: '컬러', activeText: '', value: 'color', type: 'color' },
      {
        text: '스타일',
        activeText: '',
        type: 'style',
        value: 'style',
      },
      {
        text: 'TPO',
        activeText: '',
        type: 'tpo',
        value: 'tpo',
      },
      { text: '가격', activeText: '', value: 'priceRange', type: 'priceRange' },
      {
        text: '브랜드',
        activeText: '',
        value: 'topBrand',
        type: 'brand',
        subType: ['brand', 'topBrand', 'newBrand'],
      },
      {
        text: '상품정보',
        activeText: '',
        value: 'benefit',
        type: 'benefit',
      },
    ],
    COLOR_LIST: [
      { name: '화이트', code: 'white', key: 0 },
      { name: '그레이', code: 'grey', key: 1 },
      { name: '블랙', code: 'black', key: 2 },
      { name: '레드', code: 'red', key: 3 },
      { name: '카멜', code: 'camel', key: 4 },
      { name: '옐로우', code: 'yellow', key: 5 },
      { name: '그린', code: 'green', key: 6 },
      { name: '블루', code: 'blue', key: 7 },
      { name: '네이비', code: 'navy', key: 8 },
      { name: '퍼플', code: 'purple', key: 9 },
      { name: '핑크', code: 'pink', key: 10 },
      { name: '브라운', code: 'brown', key: 11 },
      { name: '파스텔', code: 'pastel', key: 12 },
      { name: '패턴', code: 'pattern', key: 13 },
      { name: '메탈릭', code: 'metallic', key: 14 },
    ],
    BENEFIT_LIST: [
      { name: '세일중', code: 'sale', type: 'discount', key: 1 },
      { name: '상품쿠폰', code: 'coupon', type: 'discount', key: 3 },
      { name: '무료배송', code: 'freeDelivery', type: 'benefit', key: 0 },
      { name: '단독', code: 'exclusive', type: 'benefit', key: 6 },
      {
        name: '예약/주문 제외',
        code: 'excludePreOrder',
        type: 'benefit',
        key: 5,
      },
      { name: '증정품', code: 'gift', type: 'benefit', key: 2 },
    ],
    SORT_LIST: [
      { name: '신상품순', code: 'NEW', key: 0 },
      { name: '판매순', code: 'SALE', key: 1 },
      { name: '할인율순', code: 'DISCOUNT', key: 2 },
      { name: '낮은가격순', code: 'LOWPRICE', key: 3 },
      { name: '높은가격순', code: 'HIGHPRICE', key: 4 },
      { name: '리뷰순', code: 'REVIEW', key: 5 },
    ],
  },
  EXCLUSIVE: {
    SUB_TYPE: {
      BN006: 'BN006',
      TGP005: 'TGP005',
      TGP006: 'TGP006',
      BN014: 'BN014',
    },
    SORT_LIST: [
      { name: '신상품순', code: 'NEW', key: 0 },
      { name: '판매순', code: 'SALE', key: 1 },
      { name: '할인율순', code: 'DISCOUNT', key: 2 },
      { name: '낮은가격순', code: 'LOWPRICE', key: 3 },
      { name: '높은가격순', code: 'HIGHPRICE', key: 4 },
      { name: '리뷰순', code: 'REVIEW', key: 5 },
    ],
    NEW_FILTER_LIST: [
      {
        text: '카테고리',
        activeText: '',
        value: 'category',
        type: 'category',
      },
      { text: '컬러', activeText: '', value: 'color', type: 'color' },
      {
        text: '스타일',
        activeText: '',
        type: 'style',
        value: 'style',
      },
      {
        text: 'TPO',
        activeText: '',
        type: 'tpo',
        value: 'tpo',
      },
      { text: '가격', activeText: '', value: 'priceRange', type: 'priceRange' },
      {
        text: '브랜드',
        activeText: '',
        value: 'topBrand',
        type: 'brand',
        subType: ['brand', 'topBrand', 'newBrand'],
      },
      {
        text: '상품정보',
        activeText: '',
        value: 'benefit',
        type: 'benefit',
      },
    ],
    FILTER_LIST: [
      {
        text: '카테고리',
        activeText: '',
        value: 'filterCategoryTab',
        type: 'category',
      },
      { text: '컬러', activeText: '', value: 'filterColorTab', type: 'color' },
      { text: '가격', activeText: '', value: 'filterPriceTab', type: 'price' },
      {
        text: '할인/혜택',
        activeText: '',
        value: 'filterBenefitTab',
        type: 'benefit',
      },
      {
        text: '브랜드',
        activeText: '',
        value: 'filterBrandTab',
        type: 'brand',
      },
    ],
    COLOR_LIST: [
      { name: '화이트', code: 'white', key: 0 },
      { name: '그레이', code: 'grey', key: 1 },
      { name: '블랙', code: 'black', key: 2 },
      { name: '레드', code: 'red', key: 3 },
      { name: '카멜', code: 'camel', key: 4 },
      { name: '옐로우', code: 'yellow', key: 5 },
      { name: '그린', code: 'green', key: 6 },
      { name: '블루', code: 'blue', key: 7 },
      { name: '네이비', code: 'navy', key: 8 },
      { name: '퍼플', code: 'purple', key: 9 },
      { name: '핑크', code: 'pink', key: 10 },
      { name: '브라운', code: 'brown', key: 11 },
      { name: '파스텔', code: 'pastel', key: 12 },
      { name: '패턴', code: 'pattern', key: 13 },
      { name: '메탈릭', code: 'metallic', key: 14 },
    ],
    BENEFIT_LIST: [
      { name: '세일중', code: 'sale', type: 'discount', key: 1 },
      { name: '상품쿠폰', code: 'coupon', type: 'discount', key: 3 },
      { name: '무료배송', code: 'freeDelivery', type: 'benefit', key: 0 },
      { name: '단독', code: 'exclusive', type: 'benefit', key: 6 },
      {
        name: '예약/주문 제외',
        code: 'excludePreOrder',
        type: 'benefit',
        key: 5,
      },
      { name: '증정품', code: 'gift', type: 'benefit', key: 2 },
    ],
  },
  PRESHOW: {
    SUB_TYPE: {
      BN016: 'BN016',
      TP004: 'TP004',
    },
    FILTER_LIST: [
      {
        text: '브랜드',
        activeText: '',
        value: 'filterBrandTab',
        type: 'brand',
      },
    ],
    SORT_LIST: [
      { name: '추천순', code: 'WCK', key: 0 },
      { name: '최신순', code: 'NEW', key: 1 },
    ],
  },
  STYLECLIP_MAIN: {
    // 신규 LP 필터 컴포넌트라서 값이 다름
    FILTER_LIST: [
      {
        text: '스타일',
        activeText: '',
        type: 'style',
        value: 'style',
      },
      {
        text: 'TPO',
        activeText: '',
        type: 'tpo',
        value: 'tpo',
      },
      {
        text: '계절',
        activeText: '',
        value: 'season',
        type: 'season',
      },
      {
        text: '카테고리',
        activeText: '',
        value: 'category',
        type: 'category',
      },
      {
        text: '브랜드',
        activeText: '',
        value: 'topBrand',
        type: 'brand',
        subType: ['brand', 'topBrand', 'newBrand'],
      },
    ],
  },
};
